// extracted by mini-css-extract-plugin
module.exports = {"features":"Features_features__KTWR0","feature":"Features_feature__O7OPf","value":"Features_value__qldMH","label":"Features_label__7bcXu","grid":"Features_grid__NW02v"};